import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <img src="/images/logo.jpg" alt="Haridem Logo" className="footer-logo" />
          <h3>Haridem Studio</h3>
          <p>Studio fotografico premium specializzato in ritratti artistici e servizi professionali di alta qualita.</p>
          <p>Partita IVA: 01916989</p>
        </div>
        <div className="footer-section">
          <h3>Contatti</h3>
          <p>lungomare Leopoldo II di Lorena, 91</p>
          <p>58100 grosseto GR</p>
          <p>Italia</p>
          <p>Tel: +394713811587</p>
          <p>Email: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a></p>
            <p><a href="https://wa.me/394713811587">WhatsApp</a></p>
            <p><a href="https://viber.me/394713811587">Viber</a></p>
        </div>
        <div className="footer-section">
          <h3>Link Rapidi</h3>
          <Link to="/">Home</Link>
          <Link to="/about">Chi Siamo</Link>
          <Link to="/contact">Contatti</Link>
          <Link to="/cart">Carrello</Link>
        </div>
        <div className="footer-section">
          <h3>Informazioni</h3>
          <Link to="/privacy-policy">Politica sulla Privacy</Link>
          <Link to="/terms-conditions">Termini e Condizioni</Link>
          <Link to="/refund-policy">Politica di Rimborso</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="policy-links">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-conditions">Termini</Link>
          <Link to="/refund-policy">Rimborsi</Link>
        </div>
        <p>© 2026 Haridem Photography Studio. Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
}

export default Footer;